import {Env} from "../../config";

export function getCurrentUrl(pathname: string) {
    return pathname.split(/[?#]/)[0]
}

export function checkIsActive(pathname: string, url: string) {
    const current = getCurrentUrl(pathname)
    if (!current || !url) {
        return false
    }

    if (current === url) {
        return true
    }

    return current.indexOf(url) > -1;


}

export const iframeUrl = (pathname: string) => Env.REACT_APP_IFRAME + pathname;
